<form [formGroup]="form" name="importForm" (ngSubmit)="submit();submitting = true;" class="col-12">
  <fieldset [disabled]="submitting">
    <div class="row form-group">
      <div class="col-lg-5 col-xl-4">
        <label class="col-form-label lead">Select CSV file</label>
      </div>

      <div class="col-lg-7 col-xl-5 mt-2">
        <input
          id="select-csv-file"
          type="file"
          formControlName="file"
          [multiple]="false"
          (change)="onAddFile($event.target.files)"
        />
        <control-messages [control]="form.get('file')"></control-messages>
        <span *ngIf="error" class="invalid-feedback d-block error-messages" [innerText]="error"></span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-lg-5 col-xl-4">
        <label class="col-form-label lead">Expected CSV format</label>
      </div>

      <div class="col-lg-7 col-xl-5 mt-2">
        <p>Please use the following format:</p>
        <ul>
          <li>The first row must contain column names: {{getFormatText()}}</li>
          <li>Column names must be unique but can be in any order</li>
          <li>Unrecognized column names will be ignored</li>
          <li>Date field format is m/d/yyyy; e.g., {{getTomorrowDate()}}</li>
          <li>Time field format is h:mm; e.g., 6:00pm;</li>
          <li>For multi-select custom properties, values should be delimited with a ";"</li>
        </ul>

        <a class="download-button" (click)="downloadFile()" download target="_self">Download sample CSV file</a>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-lg-5 col-xl-4">
        <label class="col-form-label lead">Timezone</label>
      </div>

      <div class="mt-2 px-3 timezones">
        <frontend-dropdown-plain
          elementId="timezone"
          formControlName="timezone"
          [items]="timezones"
        ></frontend-dropdown-plain>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-lg-5 col-xl-4">
        <label class="col-form-label lead">CSV delimiter symbol</label>
      </div>
      <div class="col-3 col-sm-2 col-lg-1 mt-2">
        <input
          id="delimiter"
          class="form-control input-mini"
          type="text"
          formControlName="delimiter"
          maxlength="1"
        />
      </div>
    </div>

    <!--<div class="form-group row">
      <div class="col-lg-5 col-xl-4">
        <label class="col-form-label lead">First row contains header</label>
      </div>
      <div class="col-lg-7 col-xl-5 mt-2">
        <input
          id="column-header"
          type="checkbox"
          class="form-control check-input-import"
          formControlName="header"
          style="width: auto !important;"
        />
      </div>
    </div>-->

    <div class="d-flex justify-content-start form-group row mt-2 px-3">
      <button
        class="btn btn-info"
        type="submit"
        [disabled]="form.invalid || submitting"
        angularticsCategory="reservations"
        angulartics2On="click"
        angularticsAction="Upload Reservations CSV"
      >Upload</button>
    </div>
  </fieldset>
</form>
